import { useWindowSize } from "@coinsamba/react-tiny-hooks";
import React, { useMemo } from "react";
import { FiUsers } from "react-icons/fi";
import { useHistory } from "react-router";
import { Col, Row } from "reactstrap";
import styled from "styled-components";
import { IMobileMenuProps } from "../../typings/Trade";
import { useState } from "react";
import { IActivableComponent } from "../Trade/Pro/LeftPanel";
import { BiBitcoin } from "react-icons/bi";
import { RiDashboardLine, RiExchangeDollarFill } from "react-icons/ri";
import { GiPartyPopper } from "react-icons/gi";

const MobileMenuWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  overflow-x: scroll;
  padding: 0 15px;
  margin-bottom: 1rem;
  padding-bottom: 10px;

  ::-webkit-scrollbar {
    width: 6px;
    height: 2px;
    /* border-left: 1px solid #e6ecf8; */
  }
  ::-webkit-scrollbar-thumb {
    background-color: #e6ecf8;
  }
`;

const MobileMenuItem = styled.div<IMobileMenuProps>`
  height: auto;
  padding: 5px;
  padding-bottom: 0;
  width: 100%;
  cursor: pointer;
  border: none;
  transition: all 0.4s ease;
  border-bottom: ${(props) =>
    props.active ? `2px solid ${props.theme.primary}` : "none"};

  span {
    min-width: 174px;
    white-space: nowrap;
    width: 100%;
    padding-top: 0;
  }

  :hover {
    border-bottom: 2px solid ${(props) => props.theme.primary};
    background-color: #dbdbdb;
  }
`;

const DesktopMenuWrapper = styled.div`
  width: 100%;
  padding-bottom: 0;
  /* height: calc(100% - 120px); */
  /* position: absolute; */
  /* top: 7.5rem; */
  padding-top: 0;
  /* z-index: 4; */
  /* background-color: #fff; */
  transition: all 0.2s ease;
  /* box-shadow: 0px 15px 30px 0px rgb(0 0 0 / 2%); */
`;

const DesktopMenu = styled.ul`
  display: flex;
  flex-direction: column;
  padding-top: 15px;

  padding: 0;
  margin: 0;
  list-style: none;
`;

const DesktopMenuItem = styled.li<IActivableComponent>`
  /* padding: 0 15px; */
  height: 45px;

  span {
    transition: all 0.1s ease;
    white-space: nowrap;
    width: 100%;
    display: block;
    background: ${(props) => props.active && props.theme.primaryBackground};
    color: ${(props) => props.active && props.theme.primary};
    font-weight: 500;
    box-shadow: none;
    font-size: 18px;
    padding: 15px 15px;
    border-radius: 1.375rem;

    :hover {
      background: ${(props) => props.theme.primaryBackground};
    }
  }
`;

const AdminTemplate: React.FC = ({ children }) => {
  const router = useHistory();
  const windowSize = useWindowSize();
  const { pathname } = router.location;
  const [active, setActive] = useState(pathname);

  const menuClick = (path: string) => {
    setActive(path);
    router.push(path);
  };

  const isMobile = windowSize.width < 768;

  const menuItems = useMemo(
    () => [
      {
        text: "Panel",
        path: "/admin/panel",
        icon: RiDashboardLine,
      },
      {
        text: "Currencies",
        path: "/admin/currencies",
        icon: BiBitcoin,
      },
      {
        text: "Pairs",
        path: "/admin/pairs",
        icon: RiExchangeDollarFill,
      },
      {
        text: "Users",
        path: "/admin/users",
        icon: FiUsers,
      },
      {
        text: "Token Event",
        path: "/admin/token-event",
        icon: GiPartyPopper,
      },
    ],
    []
  );

  return (
    <Row
      className="mt-3"
      style={{
        minHeight: !isMobile ? "720px" : "100%",
      }}
    >
      {isMobile ? (
        <MobileMenuWrapper>
          {menuItems.map((m) => (
            <MobileMenuItem
              key={m.text}
              onClick={() => menuClick(m.path)}
              active={active === m.path}
            >
              <span>
                <m.icon /> {m.text}
              </span>
            </MobileMenuItem>
          ))}
        </MobileMenuWrapper>
      ) : (
        <Col sm={2}>
          <DesktopMenuWrapper>
            <DesktopMenu>
              {menuItems.map((m) => (
                <DesktopMenuItem
                  key={m.text}
                  active={active === m.path}
                  onClick={() => menuClick(m.path)}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <span>
                    <m.icon /> {m.text}
                  </span>
                </DesktopMenuItem>
              ))}
            </DesktopMenu>
          </DesktopMenuWrapper>
        </Col>
      )}

      <Col sm={isMobile ? 12 : 10}> {children} </Col>
    </Row>
  );
};

export default AdminTemplate;
